
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhatsapp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 4.875C17.125 3 14.625 2 12 2 6.5 2 2 6.5 2 12c0 1.75.5 3.5 1.375 5L2 22l5.25-1.375c1.5.75 3.125 1.25 4.75 1.25 5.5 0 10-4.5 10-10 0-2.625-1.125-5.125-3-7ZM12 20.25c-1.5 0-3-.375-4.25-1.125L7.5 19l-3.125.875.875-3L5 16.5c-.875-1.375-1.25-2.875-1.25-4.375 0-4.5 3.75-8.25 8.25-8.25 2.25 0 4.25.875 5.875 2.375 1.625 1.625 2.375 3.625 2.375 5.875 0 4.375-3.625 8.125-8.25 8.125ZM16.5 14c-.25-.125-1.5-.75-1.75-.75-.25-.125-.375-.125-.5.125s-.625.75-.75 1c-.125.125-.25.125-.5.125-.25-.125-1-.375-2-1.25-.75-.625-1.25-1.5-1.375-1.75s0-.375.125-.5l.375-.375c.125-.125.125-.25.25-.375s0-.25 0-.375S9.875 8.5 9.625 8c-.125-.375-.375-.375-.5-.375h-.5c-.125 0-.375 0-.625.25S7.125 8.75 7.125 10s.875 2.375 1 2.625c.125.125 1.75 2.75 4.25 3.75 2.125.875 2.5.625 3 .625s1.5-.625 1.625-1.125c.25-.625.25-1.125.125-1.125-.125-.625-.375-.625-.625-.75Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 4.875C17.125 3 14.625 2 12 2C6.5 2 2 6.5 2 12C2 13.75 2.50001 15.5 3.37501 17L2 22L7.25002 20.625C8.75002 21.375 10.375 21.875 12 21.875C17.5 21.875 22 17.375 22 11.875C22 9.25 20.875 6.75 19 4.875ZM12 20.25C10.5 20.25 9.00001 19.875 7.75001 19.125L7.49999 19L4.37499 19.875L5.25001 16.875L4.99999 16.5C4.12499 15.125 3.74999 13.625 3.74999 12.125C3.74999 7.625 7.5 3.875 12 3.875C14.25 3.875 16.25 4.75 17.875 6.25C19.5 7.875 20.25 9.875 20.25 12.125C20.25 16.5 16.625 20.25 12 20.25ZM16.5 14C16.25 13.875 15 13.25 14.75 13.25C14.5 13.125 14.375 13.125 14.25 13.375C14.125 13.625 13.625 14.125 13.5 14.375C13.375 14.5 13.25 14.5 13 14.5C12.75 14.375 12 14.125 11 13.25C10.25 12.625 9.75001 11.75 9.62501 11.5C9.50001 11.25 9.62502 11.125 9.75002 11C9.87502 10.875 10 10.75 10.125 10.625C10.25 10.5 10.25 10.375 10.375 10.25C10.5 10.125 10.375 10 10.375 9.875C10.375 9.75 9.87501 8.5 9.62501 8C9.50001 7.625 9.25002 7.625 9.12502 7.625C9.00002 7.625 8.87498 7.625 8.62498 7.625C8.49998 7.625 8.24998 7.625 7.99998 7.875C7.74998 8.125 7.12501 8.75 7.12501 10C7.12501 11.25 7.99999 12.375 8.12499 12.625C8.24999 12.75 9.87498 15.375 12.375 16.375C14.5 17.25 14.875 17 15.375 17C15.875 17 16.875 16.375 17 15.875C17.25 15.25 17.25 14.75 17.125 14.75C17 14.125 16.75 14.125 16.5 14Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/whatsapp.2ca080c3379950a92eab67d713679211.svg"),
        {
          React: SvgWhatsapp,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      